/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Flow_Step1Inputs */

const en_directory_submit_flow_step1 = /** @type {(inputs: Directory_Submit_Flow_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

const zh_directory_submit_flow_step1 = /** @type {(inputs: Directory_Submit_Flow_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基本信息`)
};

/**
* | output |
* | --- |
* | "Details" |
*
* @param {Directory_Submit_Flow_Step1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_flow_step1 = /** @type {((inputs?: Directory_Submit_Flow_Step1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Flow_Step1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_flow_step1(inputs)
	return zh_directory_submit_flow_step1(inputs)
});
export { directory_submit_flow_step1 as "directory.submit.flow.step1" }